import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getUserType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}user/type/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addUserType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}user/type/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getByIdUserType(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}user/type/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateUserType(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}user/type/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
